import React from 'react';

import { Box } from '@mui/material';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import {
  getActiveSection,
  getActiveSubSection,
  getSetActiveSection,
  getSetActiveSubSection,
} from 'store/useBusinessToolStore/selectors';

import { Block, useScrollManager } from 'hooks/useScrollManager';

import { Responsive } from 'components/_basic/Responsive';
import { SectionsNavigationItem } from 'components/BusinessToolForm';

import { ISidebarNavigationProps } from './types';

import styles from './SidebarNavigation.module.scss';

export const SidebarNavigation: React.FC<ISidebarNavigationProps> = ({ options }) => {
  const activeSection = useBusinessToolStore(getActiveSection);
  const setActiveSection = useBusinessToolStore(getSetActiveSection);
  const activeSubsection = useBusinessToolStore(getActiveSubSection);
  const setActiveSubsection = useBusinessToolStore(getSetActiveSubSection);

  const { leftBlockScrollToBottom, blockLeftRef, handleScroll } = useScrollManager(true);

  const renderedItems = options.map((item) => (
    <SectionsNavigationItem
      key={item.name}
      activeSection={activeSection}
      setActiveSection={setActiveSection}
      activeSubsection={activeSubsection}
      setActiveSubsection={setActiveSubsection}
      option={item}
    />
  ));

  const sectionNavigationBlock = () => {
    return (
      <Box className={styles.container} ref={blockLeftRef} onScroll={() => handleScroll(Block.BlockLeft)}>
        {options.map((item, index) => (
          <SectionsNavigationItem
            key={item.name}
            activeSection={activeSection}
            setActiveSection={setActiveSection}
            activeSubsection={activeSubsection}
            setActiveSubsection={setActiveSubsection}
            option={item}
            scrollSections={() => {
              setTimeout(() => {
                leftBlockScrollToBottom(index < 6 ? 0 : index * 50);
              });
            }}
          />
        ))}
      </Box>
    );
  };

  return (
    <>
      <Responsive mobile>
        <div className={styles['mobile_tabs']}>{renderedItems}</div>
      </Responsive>
      <Responsive aboveMobile>{sectionNavigationBlock()}</Responsive>
    </>
  );
};
